import { create } from 'zustand';
import i18n from 'i18n';
import { AccountsApi, ApiUtils, type GetCardExpirationsResponse } from '@shared/api';
import type { BaseReturn } from '@shared/types';

interface UseCardExpirationsStore {
  loading: boolean;
  data: GetCardExpirationsResponse | null;
  error?: string | null;
  getCardExpirations: (cardId: number) => Promise<BaseReturn<GetCardExpirationsResponse | null>>;
  clear: () => void;
}

export const useCardExpirationsStore = create<UseCardExpirationsStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  getCardExpirations: async (cardId) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await AccountsApi.getCardExpirations(cardId);
      set({ loading: false, data: result || null });
      return { loading: false, data: result || null };
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
